import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Tabs, Typography, Row, Col, notification } from 'antd';

import UserInfoForm from '../../components/userinfoform/userinfoform';
import UserManagement from '../../components/usermanagement/usermanagement';
import PostManagement from '../../components/postmanagement/postmanagement';
import CourseManagement from '../../components/coursemanagement/coursemanagement';
import PostCatManagement from '../../components/postcatmanagement/postcatmanagement';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';

import Subscriptioncard from '../../components/profile/subplan';
import { bindActionCreators } from "redux"
import { changePlan, removeCard, saveCard, getCards } from "../../../../core/actions/auth"
import Paymentcard from '../../components/profile/paymentcard';
import { Helmet } from "react-helmet";
import PrivacyPolicy from '../../components/privacypolicy/privacypolicy';
import TermsCondition from '../../components/terms/terms';

const { Title } = Typography;
const TabPane = Tabs.TabPane;
const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: 'Notification',
    description: message,
  });
};


class ProfileSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabStyle: 'left'
    };
  }

  componentDidMount() {
    if (!this.props.auth.uid) this.props.history.push('/signin');
    this.props.getCards(this.props.auth.uid)
  }

  componentWillMount() {
    this.switchTabStyle()
  }


  componentWillReceiveProps(nextProps) {
    const { ppContentSuccess, localAuth, tcContentSuccess } = nextProps
    if (localAuth.deleteUserSuccess === true) {
      openNotificationWithIcon('success', 'User deleted successfully')
    }
    if (ppContentSuccess.length > 0) {
      openNotificationWithIcon('success', ppContentSuccess)
    }
    if (tcContentSuccess.length > 0) {
      openNotificationWithIcon('success', tcContentSuccess)
    }
  }

  switchTabStyle = () => {
    let size = window.innerWidth
    if (size <= 415) {
      this.setState({
        tabStyle: 'top'
      })
    }
  }

  render() {
    console.log(this.props)
    var { profile, localAuth, changePlan } = this.props
    // console.log(profile)
    const { tabStyle } = this.state
    return (
      this.props.profile.isLoaded ? <div>
        <Helmet>
          <title>Settings</title>
        </Helmet>
        <TopNav history={this.props.history} />
        <section id="profile-settings">
          <Tabs defaultActiveKey="1" tabPosition={tabStyle}>
            <TabPane tab="Account" key="1">
              <Row>
                <Col sm={24} lg={22}>
                  <h2 className="heading" >Personal Information</h2>
                  <p>We ensure you profile details are only visible to you</p>
                </Col>
                <Col sm={0} lg={2}>
                  <i className="far fa-user xlarge" ></i>
                </Col>
              </Row>
              <hr />
              <UserInfoForm />
            </TabPane>
            {profile.admin &&
              <TabPane tab="User Management" key="2">
                <Row>
                  <Col sm={24} lg={22}>
                    <h2 className="heading" >User Management</h2>
                    <p>Manage user profile</p>
                  </Col>
                  <Col sm={0} lg={2}>
                    <i className="fas fa-users xlarge" ></i>
                  </Col>
                </Row>
                <hr />

                <UserManagement />
              </TabPane>}
            {profile.admin &&
              <TabPane tab="Draft" key="3">
                <Row>
                  <Col sm={24} lg={22}>
                    <h2 className="heading" >Draft</h2>
                    <p>All the courses you saved displays here</p>
                  </Col>
                  <Col sm={0} lg={2}>
                    <i className="fas fa-swatchbook xlarge" ></i>
                  </Col>
                </Row>
                <hr />
                <CourseManagement />
              </TabPane>}
            {profile.admin &&
              <TabPane tab="Post Management" key="4">
                <Row>
                  <Col sm={24} lg={22}>
                    <h2 className="heading" >Post Management</h2>
                    <p>Manage blog posts</p>
                  </Col>
                  <Col sm={0} lg={2}>
                    <i className="fas fa-book xlarge" ></i>
                  </Col>
                </Row>
                <hr />
                <PostManagement />
              </TabPane>}
            {profile.admin &&
              <TabPane tab="Post Category Management" key="5">
                <Row>
                  <Col sm={24} lg={22}>
                    <h2 className="heading" >Post Category Management</h2>
                    <p>Manage blog post categories</p>
                  </Col>
                  <Col sm={0} lg={2}>
                    <i className="fas fa-align-right xlarge"></i>
                  </Col>
                </Row>
                <hr />
                <PostCatManagement />
              </TabPane>}
            {
              !profile.admin &&
              <TabPane tab="Payment & Subscriptions" key="6">
                <Row>
                  <Col sm={24} lg={22}>
                    <h2 className="heading" >Payments & Subscriptions</h2>
                    <p>Pay with our secure payment gateway</p>
                  </Col>
                  <Col sm={0} lg={2}>
                    <i className="fas fa-money-check-alt xlarge" ></i>
                  </Col>
                </Row>

                <hr />
                <Subscriptioncard
                  auth={localAuth}
                  changePlan={changePlan}
                  cards={this.props.cards}
                  profile={profile} />

                <Paymentcard
                  getCards={this.props.getCards}
                  cards={this.props.cards}
                  auth={localAuth}
                  removeCard={this.props.removeCard}
                  saveCard={this.props.saveCard}
                  profile={profile}
                />

              </TabPane>
            }
            {
              profile.admin && <TabPane tab="Privacy & Policy" key="7">
                <Row>
                  <Col sm={24} lg={22}>
                    <h2 className="heading" >Privacy & Policy</h2>
                    <p>Manage privacy & policy content.</p>
                  </Col>
                  <Col sm={0} lg={2}>
                    <i className="fas fa-align-right xlarge"></i>
                  </Col>
                </Row>
                <hr />
                <PrivacyPolicy />
              </TabPane>
            }
            {
              profile.admin && <TabPane tab="Terms & Condition" key="8">
                <Row>
                  <Col sm={24} lg={22}>
                    <h2 className="heading" >Terms & Condition</h2>
                    <p>Manage terms & condition content.</p>
                  </Col>
                  <Col sm={0} lg={2}>
                    <i className="fas fa-align-right xlarge"></i>
                  </Col>
                </Row>
                <hr />
                <TermsCondition />
              </TabPane>
            }

          </Tabs>
        </section>
        <Footer />
      </div> : null
    );
  }
}

const mapStateToProps = state => ({
  profile: state.firebase.profile,
  auth: state.firebase.auth,
  localAuth: state.auth,
  cards: state.cards.cards,
  ppContentSuccess: state.ppContents.ppContentSuccess,
  tcContentSuccess: state.tcContents.tcContentSuccess
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  changePlan,
  saveCard,
  getCards,
  removeCard
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileSettings);
